<template>
  <a-menu offset-y dense nudge-bottom="2" v-model="isOpen">
    <template v-slot:activator="{ on: menu, attrs }">
      <a-btn
        class="ml-3"
        color="primaryDark2"
        small
        v-bind="attrs"
        v-on="{ ...menu }"
      >
        {{ $t("btnEdit") }}
        <v-icon v-if="isOpen" class="ml-3" color="white">mdi-chevron-up</v-icon>
        <v-icon v-else class="ml-3" color="white">mdi-chevron-down</v-icon>
      </a-btn>
    </template>
    <v-list dense style="padding: 0">
      <v-list-item
        v-for="option in editOptions"
        :key="option.value"
        @click="onEditSelection(option.value)"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-title v-on="on" v-bind="attrs">{{
              option.text
            }}</v-list-item-title>
          </template>
          <span>{{ option.tooltipText }}</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
  </a-menu>
</template>

<script>
export default {
  name: "EditRecurrenceButton",
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    editOptions() {
      return [
        {
          text: this.$t("lblEditOccurrence"),
          value: "occurrence",
          tooltipText: this.$t("tipEditOccurrence"),
        },
        {
          text: this.$t("lblEditSeries"),
          value: "series",
          tooltipText: this.$t("tipEditSeries"),
        },
      ];
    },
  },
  methods: {
    onEditSelection,
  },
};

function onEditSelection(action) {
  this.$emit("onEdit", action === "series" || false);
}
</script>

<style>
</style>